import * as SceneManager from "../sceneManager";
import {layoutCamera, sceneCamera} from "../sceneManager";
import {buildingGroup, furnitureGroup, highlightsGroup, isDeleteMode, roomGroup, checkMode} from "../main";
import {getWallGroupParent, isFloor, isRoof, isRoofOrFloor, isWallGroup} from "./configuratorUtils";
import {findChildrenByName, getHighestParentGroup, getIntersectedObjectByName, setMaterial} from "./threeUtils";
import {Box3, Mesh, PlaneGeometry, Vector3} from "three";
import * as Globals from "../globals";
import {layerEnabled, setObjectLayer} from "./layerUtils";
import {cursorTarget, setCursor} from "./utils";
import {getWallOrientation} from "../models/walls/wall";
import {clearRoomState} from "../models/rooms/roomGeneration";
import {resetRoomLineMaterials} from "../models/rooms/roomLineGeneration";
import * as nameContants from "../constants/nameConstants";
import {controlObjectName, pillarMeshName, supportBeamMeshName} from "../constants/nameConstants";
import {highlightMaterial, previewNotAllowedMaterial} from "../constants/materialConstants";

export let highlightingObject, highlightedObject, highlightedObjectType = null;

var selectedObj = [];

export function clearHighlightingState() {
    highlightedObject = null;
    highlightedObjectType = null;
    highlightingObject = null;

    SceneManager.clearGroup(highlightsGroup);
}

export function getSelectedObj()
{
    return selectedObj;
}

export function resetSelectedObj()
{
    selectedObj = [];
}

export function selectHighlightedObj(obj, maxSelectedItems = 2)
{
    console.log('select object', obj);
    if (selectedObj.find(selected => selected.uuid == obj.uuid)) {
        return;
    }
    selectedObj.push(obj);
    if (selectedObj.length > maxSelectedItems) {
        selectedObj.splice(0, selectedObj.length-maxSelectedItems);
    }
}

export function getObjectFromMousePosition(isSceneView = false, mouseCoords = null) {
    if (mouseCoords !== null) {
        let camera = isSceneView ? sceneCamera : layoutCamera;
        SceneManager.raycaster.setFromCamera(mouseCoords, camera);
    }
    let filteredIntersects = [];
    //TODO: Performance: Nicht ganze buildinggroup rekursiv durchlaufen. Bei Veränderung Liste alle relevanten Elemente updaten und nur diese intersecten.
    //TODO: Performance: Do not run through the entire buildinggroup recursively. When changing the list, update all relevant elements and only intersect these.
    let intersect = SceneManager.raycaster.intersectObject(buildingGroup, true);
    if (intersect.length > 0) {
        for (let i = 0; i < intersect.length; i++) {
            let object = intersect[i].object;
            let name = object.name.toLowerCase();
            if ((isRoof(object) && !isSceneView) ||
                !( name.includes("handle") || name === controlObjectName.toLowerCase() || name.includes("floormesh") || name.includes("wallmesh") || name.includes(pillarMeshName.toLowerCase()) || name.includes(supportBeamMeshName.toLowerCase()))
                || name === "" || name.includes("wallmeshbbox")) {
                continue;
            }
            //console.log("will add to filteredIntersects",object);
            filteredIntersects.push(object);
        }
    }

    //console.log('filteredIntersects', filteredIntersects);

    if (isSceneView) {
        //Dach nur in SceneView auswählbar
        if (layerEnabled(sceneCamera, Globals.layers.roof)) {
            let intersectedRoofs = getIntersectedObjectByName(filteredIntersects, "wallMesh", true);
            if (intersectedRoofs.length > 0) {
                for (let i = 0; i < intersectedRoofs.length; i++) {
                    let element = intersectedRoofs[i];
                    let roof = getHighestParentGroup(buildingGroup, element);

                    if (!isRoof(roof)) {
                        continue;
                    }

                    return {type: "roof", object: roof};
                }
            }
        }
    }

    //Sortiert nach Priorität mit welcher die Elemente gelöscht werden sollen
    //Sorted according to the priority with which the elements are to be deleted
    let intersectedControls = getIntersectedObjectByName(filteredIntersects, controlObjectName);
    if (intersectedControls.length > 0) {
        let controlObject = intersectedControls[0];
        return {type: "controlObject", object: controlObject};
    }

    let intersectedWalls = getIntersectedObjectByName(filteredIntersects, "wallMesh", true);
    if (intersectedWalls.length > 0) {
        for (let i = 0; i < intersectedWalls.length; i++) {
            let wallMesh = intersectedWalls[i];
            if (isRoofOrFloor(wallMesh)) {
                continue;
            }

            if (isWallGroup(wallMesh)) {
                let wallGroup = getWallGroupParent(wallMesh);
                if (wallGroup === null) {
                    continue;
                }

                return {type: nameContants.wallGroupName, object: wallGroup};
            }
            //TODO: Anpassung stimmt noch nicht bei regulären Wänden wahrscheinlich wegen Größe die gespeichert wird
            //TODO: Adjustment is not yet correct for regular walls probably due to size that is saved
        }
    }

    let handles = getIntersectedObjectByName(filteredIntersects, "handle", true);
    if (handles.length > 0) {
        let handle = handles[0];
        if(handle.name == "startHandle"){
            return {type: "startHandle", object: handle};
        } else if(handle.name == "endHandle"){
            return {type: "endHandle", object: handle};
        }

    }


    let intersectedPillars = getIntersectedObjectByName(filteredIntersects, pillarMeshName);
    if (intersectedPillars.length > 0) {
        let pillar = intersectedPillars[0];
        return {type: "pillar", object: pillar};
    }

    let intersectedSupportBeams = getIntersectedObjectByName(filteredIntersects, supportBeamMeshName);
    if (intersectedSupportBeams.length > 0) {
        let supportBeam = intersectedSupportBeams[0];
        return {type: "beam", object: supportBeam};
    }

    let intersectedFurniture = SceneManager.raycaster.intersectObjects(furnitureGroup.children, true);
    if (intersectedFurniture.length > 0) {
        let object = intersectedFurniture[0].object;
        object = getHighestParentGroup(furnitureGroup, object);
        return {type: "furniture", object: object};
    }

    if (isSceneView) {
        //TODO: Grundplatte kann nicht so ausgewählt werden. Erweitern um Grundplattenmesh
        let intersectedFloors = getIntersectedObjectByName(filteredIntersects, "wallMesh", true);
        intersectedFloors = intersectedFloors.concat(getIntersectedObjectByName(filteredIntersects, "floorMesh", true));
        if (intersectedFloors.length > 0) {
            for (let i = 0; i < intersectedFloors.length; i++) {
                let element = intersectedFloors[i];
                let floor = getHighestParentGroup(buildingGroup, element);
                if (!isFloor(floor)) {
                    continue;
                }

                return {type: "floor", object: floor};
            }
        }
    }

    if (!isSceneView && isDeleteMode) {
        let roomLineElements = findChildrenByName(buildingGroup, "roomLineMesh", true, true);
        let intersectedRoomLines = SceneManager.raycaster.intersectObjects(roomLineElements, false);
        if (intersectedRoomLines.length > 0) {
            for (let i = 0; i < intersectedRoomLines.length; i++) {
                let element = intersectedRoomLines[i].object;
                let parent = getHighestParentGroup(buildingGroup, element);
                if (parent !== null) {
                    return {type: "roomLine", object: parent};
                }
            }
        }
    }

    if (!isSceneView) {
        //TODO Kann auf leere Objekte zugreifen wenn alles gelösch wird
        let intersectedRooms = SceneManager.raycaster.intersectObjects(roomGroup.children, true);
        if (intersectedRooms.length > 0) {
            let element = intersectedRooms[0].object;
            let room = getHighestParentGroup(roomGroup, element);
            return {type: "room", object: room};
        }
    }

    return {type: null, object: null};

    //TODO: Weitere Elemente
}

export function highlightObject(data, overwrite = false) {
    let canUpdateCursor = !isDeleteMode && !checkMode(Globals.modes.measurement);
    if (data.type === null && data.object === null) {
        clearRoomState();
        resetRoomLineMaterials();
        SceneManager.clearGroup(highlightsGroup);
        highlightedObject = null;
        highlightedObjectType = null;

        if (canUpdateCursor) {
            setCursor(Globals.cursors.default, cursorTarget.both);
        }
        return;
    }

    if (highlightedObject === data.object && !overwrite) {
        return;
    } else {
        clearRoomState();
        resetRoomLineMaterials();
        SceneManager.clearGroup(highlightsGroup);
    }

    highlightedObject = data.object;

    let updatedCursor = null;
    if (data.type === "controlObject") {
        highlightedObjectType = data.object.userData.type;
        updatedCursor = Globals.cursors.grab;
    } else if (data.type === nameContants.wallGroupName) {
        highlightedObjectType = data.type;
        highlightingObject = highlightWall(data.object);
        updatedCursor = Globals.cursors.grab;
    } else if (data.type === "roomLine") {
        highlightedObjectType = data.type;
        highlightingObject = highlightRoomLine(data.object);
        updatedCursor = Globals.cursors.default;
    } else if (data.type === "pillar") {
        highlightedObjectType = data.type;
        highlightingObject = null; //TODO: Eventuell highlighten?
        updatedCursor = Globals.cursors.default;
    } else if (data.type === "beam") {
        highlightedObjectType = data.type;
        highlightingObject = null; //TODO: Eventuell highlighten?
        updatedCursor = Globals.cursors.default;
    }/* else if (data.type === "room") {
        highlightedObjectType = data.type;
        highlightingObject = highlightRoom(data.object);
        setCursor(Globals.cursors.default)
        return;
    }*/

    if (updatedCursor !== null) {
        if (canUpdateCursor) {
            setCursor(updatedCursor, cursorTarget.layoutView);
        }
        return;
    }

    highlightedObject = null;
    highlightedObjectType = null;
    if (canUpdateCursor) {
        setCursor(Globals.cursors.default, cursorTarget.both);
    }
    SceneManager.clearGroup(highlightsGroup);
}

// färbt einen Raum, wenn der ausgewählte Raum nicht gefärbt ist
// entfärbt einen Raum, wenn der ausgewählte Raum gefärbt ist
function highlightRoom(room) {
    clearRoomState();
    room.visible = true;
    return room;
}

function highlightRoomLine(roomLineGroup) {
    setMaterial(roomLineGroup, previewNotAllowedMaterial, true);
    return roomLineGroup;
}

function highlightWall(wallGroup) {
    if (wallGroup.children.length <= 0) {
        return;
    }

    let boundingBox = new Box3();
    for (let i = 0; i < wallGroup.children.length; i++) {
        let child = wallGroup.children[i];
        if (child.name.includes("wallMesh")) {
            if (!Number.isFinite(child.position.x) || !Number.isFinite(child.position.z)) {
                child.removeFromParent();
                continue;
            }
            boundingBox.expandByObject(child);
        }
    }

    let centerPoint = boundingBox.getCenter(new Vector3());
    let orientation = getWallOrientation(wallGroup);
    let size = boundingBox.getSize(new Vector3());
    let length = orientation === "x" ? size.x : size.z;
    let highlightMesh = new Mesh(new PlaneGeometry(length, Globals.HBEWallDefaultThickness), highlightMaterial);
    highlightMesh.rotateX(Math.PI / 2);
    if (orientation === "z") {
        highlightMesh.rotateZ(Math.PI / 2);
    }

    highlightMesh.position.set(centerPoint.x, Globals.defaultWallHeight, centerPoint.z);
    highlightMesh.name = "wallHighlight";
    setObjectLayer(highlightMesh, Globals.layers.layoutViewOnly);
    highlightsGroup.addWithUuid(highlightMesh);
    return highlightMesh;
}
